import { Box, Fab, Tooltip, Zoom } from '@mui/material';
import React from 'react';

export interface WhatsappFABProps {
    /** WhatsApp phone number in international format without +, e.g. "972501234567" */
    phoneNumber: string;
    /** Pre-filled message text (optional) */
    message?: string;
    /** Tooltip label. Defaults to "שלח הודעה ב-WhatsApp" */
    tooltipLabel?: string;
    /** Position from bottom of viewport. Defaults to 24 */
    bottom?: number;
    /** Position from the inline-end edge (right in LTR, left in RTL). Defaults to 24 */
    insetInlineEnd?: number;
}

const WhatsappFAB: React.FC<WhatsappFABProps> = ({
    phoneNumber,
    message,
    tooltipLabel = 'שלח הודעה ב-WhatsApp',
    bottom = 24,
    insetInlineEnd = 24,
}) => {
    const href = message
        ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
        : `https://wa.me/${phoneNumber}`;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom,
                insetInlineEnd,
                zIndex: (theme) => theme.zIndex.speedDial,
            }}
        >
            <Tooltip title={tooltipLabel} placement="left" TransitionComponent={Zoom}>
                <Fab
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={tooltipLabel}
                    sx={{
                        backgroundColor: '#25D366',
                        color: '#fff',
                        width: 56,
                        height: 56,
                        boxShadow: '0 4px 16px rgba(37,211,102,0.45)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        '&:hover': {
                            backgroundColor: '#1ebe5d',
                            transform: 'scale(1.08)',
                            boxShadow: '0 8px 24px rgba(37,211,102,0.55)',
                        },
                    }}
                >
                    {/* WhatsApp SVG icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 48 48"
                        width="28"
                        height="28"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M24 4C12.954 4 4 12.954 4 24c0 3.607.96 7.001 2.632 9.938L4 44l10.287-2.596A19.916 19.916 0 0 0 24 44c11.046 0 20-8.954 20-20S35.046 4 24 4zm0 3c9.389 0 17 7.611 17 17s-7.611 17-17 17a16.94 16.94 0 0 1-8.72-2.408l-.617-.378-6.104 1.541 1.576-5.932-.408-.645A16.94 16.94 0 0 1 7 24c0-9.389 7.611-17 17-17zm-5.4 8c-.3 0-.787.112-1.2.562-.412.45-1.575 1.538-1.575 3.75s1.613 4.35 1.838 4.65c.224.3 3.137 4.987 7.724 6.788 1.05.412 1.875.637 2.512.825.863.262 1.65.225 2.25.137.688-.1 2.1-.862 2.4-1.687.3-.825.3-1.538.212-1.688-.087-.15-.337-.225-.7-.412-.363-.188-2.1-1.05-2.425-1.163-.325-.112-.563-.163-.8.163-.237.325-.912 1.162-1.125 1.4-.212.237-.412.262-.75.088-.337-.175-1.425-.525-2.712-1.675-1-.9-1.675-2.012-1.875-2.35-.2-.337-.025-.525.15-.7.163-.162.362-.425.537-.637.175-.213.237-.363.362-.6.125-.238.063-.45-.025-.638-.087-.187-.8-1.912-1.1-2.612-.288-.675-.587-.587-.8-.6-.2-.013-.437-.013-.675-.013z" />
                    </svg>
                </Fab>
            </Tooltip>
        </Box>
    );
};

export default WhatsappFAB;
